export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14632.4bfee45f.jpg";